export const GET_CUSTOMERS = "getCustomers";
export const GET_CUSTOMER_BY_ID = "getCustomerById";
